import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EmojiSubgroup as EmojiSubgroupType, SkinTone, SkinToneOption } from '@appTypes/emoji';
import { EmojiCard } from './EmojiCard';

interface EmojiSubgroupProps {
  subgroup: EmojiSubgroupType;
  onEmojiClick: (emoji: string, event: React.SyntheticEvent<HTMLElement>) => void;
  skinTone?: SkinTone;
  skinToneOptions?: SkinToneOption[];
}

export const EmojiSubgroup = React.memo(
  ({ subgroup, onEmojiClick, skinTone = 'default', skinToneOptions }: EmojiSubgroupProps) => {
    const { t } = useTranslation();

    if (subgroup.emojis.length === 0) {
      return null;
    }

    // Get the subgroup name using the translation key
    const getLocalizedSubgroupName = () => {
      return t(subgroup.nameKey, subgroup.id);
    };

    return (
      <Box className="emoji-subgroup" sx={{ mb: 3 }}>
        <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 500, color: 'text.secondary' }}>
          {getLocalizedSubgroupName()}
        </Typography>
        <Grid container spacing={0.75}>
          {subgroup.emojis.map((emoji, index) => (
            <Grid item key={`${emoji.char}-${index}`} xs={3} sm={2} md={2} lg={1} xl={1}>
              <EmojiCard
                emoji={emoji}
                onEmojiClick={onEmojiClick}
                skinTone={skinTone}
                skinToneOptions={skinToneOptions}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }
);
EmojiSubgroup.displayName = 'EmojiSubgroup';
